const ENDPOINT = "https://insights.mycompartner.fr/api/public/track-submission";
const SITE_KEY = "mck_ea2c27d631767bce";

const SOCIAL: Record<string, string> = {
  "facebook.com": "facebook", "fb.com": "facebook", "instagram.com": "instagram",
  "linkedin.com": "linkedin", "tiktok.com": "tiktok", "youtube.com": "youtube",
  "youtu.be": "youtube", "x.com": "x", "twitter.com": "x", "pinterest.com": "pinterest",
};
const BOOKING: Record<string, string> = {
  "lokki.rent": "lokki", "lokki.com": "lokki", "lokki.fr": "lokki",
  "planity.com": "planity", "calendly.com": "calendly", "doctolib.fr": "doctolib",
  "treatwell.fr": "treatwell", "anybuddyapp.com": "anybuddy", "doinsport.club": "doinsport",
  "playtomic.io": "playtomic", "playtomic.com": "playtomic",
};

export function trackClick(type: "phone" | "email" | "social" | "booking", label: string) {
  try {
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ site_key: SITE_KEY, type, label }),
      keepalive: true,
    }).catch(() => {});
  } catch {}
}

function match(host: string, map: Record<string, string>) {
  for (const domain in map) if (host === domain || host.endsWith("." + domain)) return map[domain];
  return null;
}

export function installClickTracking() {
  if (typeof window === "undefined") return;
  const w = window as unknown as { __mycomClicks?: boolean };
  if (w.__mycomClicks) return;
  w.__mycomClicks = true;
  document.addEventListener("click", (e) => {
    const a = (e.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
    if (!a) return;
    const href = a.getAttribute("href") || "";
    const zone = a.closest("header") ? "header" : a.closest("footer") ? "footer" : "page";
    if (/^tel:/i.test(href)) return trackClick("phone", zone);
    if (/^mailto:/i.test(href)) return trackClick("email", zone);
    let url: URL;
    try { url = new URL(href, location.href); } catch { return; }
    if (url.hostname === location.hostname) return;
    const host = url.hostname.replace(/^www\./, "").toLowerCase();
    if (host === "wa.me" || host.endsWith("whatsapp.com")) return trackClick("phone", "whatsapp");
    const booking = match(host, BOOKING);
    if (booking) return trackClick("booking", booking);
    const social = match(host, SOCIAL);
    if (social) return trackClick("social", social);
  }, { capture: true, passive: true });
}
